import React from 'react';
import { Typography } from '@mui/material';

interface IProps {
  title: string;
  /** Buttons placed to the right of the title, e.g. "Neue Ziehung". */
  actions?: React.ReactNode;
}

/**
 * Title row of a page. It keeps the same height whether or not it carries a
 * button, so the heading stays in place when the user switches pages — and when
 * a missing permission hides the button.
 */
export const PageHeader: React.FC<IProps> = ({ title, actions }) => (
  <div className="psf-page-header">
    <Typography variant="h1">{title}</Typography>
    {actions}
  </div>
);
